export default {
  ekaterinburg: [
    {
      title: 'Полное наименование предприятия',
      text: 'Общество с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '6670121971',
    },
    {
      title: 'КПП',
      text: '667801001',
    },
    {
      title: 'ОГРН',
      text: '1069670120178',
    },
    {
      title: 'Юридический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Фактический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Электронная почта',
      text: 'office.e@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Янковенко Владимир Викторович',
    },
  ],
  krasnoyarsk: [
    {
      title: 'Полное наименование предприятия',
      text: 'Общество с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '2460227734',
    },
    {
      title: 'КПП',
      text: '246001001',
    },
    {
      title: 'ОГРН',
      text: '1112468002261',
    },
    {
      title: 'Юридический адрес',
      text: '660018, Красноярск, ул. Яковлева 57, 70',
    },
    {
      title: 'Фактический адрес',
      text: '660017, Красноярск, ул. Красной Армии 10, стр 5',
    },
    {
      title: 'Электронная почта',
      text: 'office.k@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Бидус Борис Михайлович',
    },
  ],
  sochi: [
    {
      title: 'Полное наименование предприятия',
      text:
        'Филиал «Сочинский» Общества с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '6670121971',
    },
    {
      title: 'КПП',
      text: '236643001',
    },
    {
      title: 'ОГРН',
      text: '1069670120178',
    },
    {
      title: 'Юридический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Фактический адрес',
      text: '354057, Краснодарский край, г. Сочи, ул. Невская, д. 23, офис 14',
    },
    {
      title: 'Электронная почта',
      text: 'office.s@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Васильев Константин Олегович',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/data/mockCompaniesInfo.js